// extracted by mini-css-extract-plugin
export default {"not-found":"d4c3d4","notFound":"d4c3d4","not-found__header":"efc1ce","notFoundHeader":"efc1ce","not-found__desc":"a6a7a2","notFoundDesc":"a6a7a2"};